// In src/pages/VolunteerHistoryPage.js

import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { db } from '../services/firebase';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import {
  Container, Typography, Paper, List, ListItem, ListItemText,
  CircularProgress, Divider, Box,
} from '@mui/material';

function VolunteerHistoryPage() {
  const { currentUser } = useAuth();
  const [history, setHistory] = useState([]);
  const [totalHours, setTotalHours] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser?.uid) return;

    const historyQuery = query(
      collection(db, `users/${currentUser.uid}/volunteerHistory`),
      orderBy('dateServed', 'desc')
    );

    const unsubscribe = onSnapshot(historyQuery, (snapshot) => {
      const historyData = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      const total = historyData.reduce((sum, item) => sum + item.hoursLogged, 0);
      setHistory(historyData);
      setTotalHours(total);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser?.uid]);

  if (loading) return <CircularProgress />;

  return (
    <Container maxWidth="md">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4">My Volunteer History</Typography>
        <Typography variant="h5">Total Hours: {totalHours.toFixed(1)}</Typography>
      </Box>
      <Paper>
        <List>
          {history.length === 0 && (
            <ListItem><ListItemText primary="No volunteer hours have been logged yet." /></ListItem>
          )}
          {history.map((item, index) => (
            <React.Fragment key={item.id}>
              <ListItem>
                <ListItemText
                  primary={item.opportunityTitle}
                  secondary={`Served on: ${item.dateServed.toDate().toLocaleDateString()}`}
                />
                <Typography variant="h6">{item.hoursLogged.toFixed(1)} hrs</Typography>
              </ListItem>
              {index < history.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Paper>
    </Container>
  );
}

export default VolunteerHistoryPage;